<template>
  <el-dialog
    title=""
    :visible.sync="dialogVisible"
    :width="dialogWidth"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <div style="min-height: 220px">
      <el-card class="box-card" shadow="hover" style="margin-bottom: 20px">
        <div slot="header" class="clearfix">
          <span>问题：</span>
        </div>
        <div class="text item" style="padding-left: 40px">
          {{ question }}
        </div>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
          <span>回复：</span>
        </div>
        <div class="text item" style="padding-left: 40px">
          {{ answer }}
        </div>
      </el-card>
    </div>
  </el-dialog>
</template>
<script>
import { getLeaveMessageDetail } from "@/api/moudles/user";
export default {
  data() {
    return {
      dialogVisible: false,
      question: "",
      answer: "",
      dialogWidth: "30%",
    };
  },
  mounted() {
    console.log(this.$phoneSize());
    if (this.$phoneSize()) {
      this.dialogWidth = "95%";
    } else {
      this.dialogWidth = "30%";
    }
  },
  methods: {
    open(row) {
      console.log(row);
      const { id } = row;
      this.getDetail(id);
      this.dialogVisible = true;
    },
    async getDetail(id) {
      await getLeaveMessageDetail({
        data: {
          id,
        },
        success: (res) => {
          if (res.data) {
            this.question = res.data.question;
            this.answer = res.data.content;
          } else {
            this.question = "";
            this.answer = "";
          }
        },
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.textarea = "";
    },
  },
};
</script>
